import React from 'react';
import ElliottWorking from '../../../../../components/ui/ElliottWorking';
import { GenerationProgress } from '../types';

interface GeneratingOverlayProps {
  message?: string;
  progress?: GenerationProgress | null;
}

// Full-area "Elliott is working" state for a whole-program build. Kept as a
// thin wrapper so existing callers keep their props; the look is the shared
// ElliottWorking component.
const GeneratingOverlay: React.FC<GeneratingOverlayProps> = ({
  message = 'Elliott is writing every lesson in your program...',
  progress
}) => (
  <ElliottWorking
    size="full"
    message={message}
    progress={
      progress && progress.totalLessons > 0
        ? { done: progress.completedLessons, total: progress.totalLessons, unit: 'lessons' }
        : null
    }
  />
);

export default GeneratingOverlay;
